import { restClient } from '@/Core'

/** Валюта так, як її віддає картка валюти ядра. */
export interface CurrencyRef {
    '@id'?: string
    uuid?: string
    code?: string
    title?: string
}

const pending = new Map<string, Promise<CurrencyRef | null>>()

/**
 * Валюта за кодом — `GET /services/currencies/<код>` (ядро адресує валюту
 * кодом, тож зашитого IRI, як у легасі `ApplicationResource.jsx:152-157`, тут
 * немає). Один запит на код за сесію; невдалий не кешуємо.
 */
export const LoadCurrencyTask = (code: string): Promise<CurrencyRef | null> => {
    let promise = pending.get(code)

    if (!promise) {
        promise = (async () => {
            try {
                const currency = (await restClient.get(`/services/currencies/${encodeURIComponent(code)}`)) as unknown as CurrencyRef | null

                return currency && typeof currency === 'object' ? currency : null
            } catch {
                pending.delete(code)

                return null
            }
        })()
        pending.set(code, promise)
    }

    return promise
}
